import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { receive, receiveBig } from '../Actions/QuickSearch.action';
import SmdIcon from './SmdIcon';
import EnhancedBuyButton from './EnhancedBuyButton';
import { receive as receiveCart, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { add as addToCartService } from '../Services/Cart.service';
import { translate } from '../Services/translation';
import CustomerPrices from './CustomerPrices';
import QuantityInput from './QuantityInput';
import { highlightQuantityInput } from '../Actions/QuantityInput.action';

const QuickSearchResult = ({
  result,
  searchUrl,
  isBigSearch,
}) => {
  const dispatch = useDispatch();
  const quantityFields = useSelector(state => {
    return state.quantityInput.quantityFields});

  const onToggle = (index) => {
    result[index].closed = !result[index].closed;
    if (isBigSearch) {
      dispatch(receiveBig(result));
    } else {
      dispatch(receive(result));
    }
  };

  const onClickHandler = async ({ item }) => {
    try {
      const cartResponse = await addToCartService({
        articleNumber: item.articleNumber,
        quantity: quantityFields[item.id].value,
      });
      dispatch(receiveCart(cartResponse));

      if (isBigSearch) {
        dispatch(receiveBig(result));
      } else {
        dispatch(receive(result));
      }

      return true;
    } catch (ex) {
      dispatch(catchError(ex, (error) => loadError(error)));
      return false;
    }
  };

  return (
    <div
      className={`quick-search-result ${
        isBigSearch ? 'quick-search-result__big' : ''
      }`}
    >
      {result &&
        result.map((item, index) => (
          <Fragment key={`${item.name}-${index}`}>
            {item.showAll ? (
              <a className="quick-search-result__show-all" href={searchUrl}>
                {item.name}
              </a>
            ) : item.category == 'NoHit' ? (
              <article className="product-list-item">
                <div className="product-list-item__wrapper no-result">
                  <div className="product-list-item__name-wrapper no-result">
                    <h4 className="product-list-item__name no-result">
                      {item.name}
                    </h4>
                  </div>
                </div>
              </article>
            ) : (
              <article className="product-list-item product-list-item__separator">
                <div
                  className={`product-list-item__wrapper ${
                    item.closed ? 'closed' : ''
                  }`}
                >
                  <button
                    type="button"
                    className="product-list-item__toggle"
                    onClick={() => onToggle(index)}
                  >
                    <SmdIcon icon="caret-down"></SmdIcon>
                  </button>
                  <p
                    className="product-list-item__article-number"
                    itemProp="ProductId"
                  >
                    {translate('code.product.articlenumbershort')}{' '}
                    {item.articleNumber}
                  </p>
                  {item.hasImage && item.imageSource && (
                    <figure className="product-list-item__image">
                      <img
                        alt={item.name}
                        className="image"
                        src={item.imageSource}
                      />
                    </figure>
                  )}
                  <div className="product-list-item__name-wrapper">
                    <a
                      href={item.showAll ? searchUrl : item.url}
                      target="_self"
                      rel="noreferrer"
                    >
                      <h4 className="product-list-item__name" itemProp="name">
                        {item.name}
                      </h4>
                    </a>
                    <p className="product-list-item__description">
                      {item.unitQuantityDescription}
                    </p>
                  </div>
                  <p className="product-list-item__prices">
                    {item.basePrice && (
                      <span className="product-list-item__list-price">
                        ({translate('code.product.baseprice')} {item.basePrice})
                      </span>
                    )}
                    {item.isBasePrice ? (
                      <CustomerPrices mode="list" variantSystemId={item.id} fetchPrices={index + 1 === result.length} />
                    ) : (
                      <Fragment>
                        <span className="product-list-item__net-price">
                          {item.price}
                        </span>
                        <span className="product-list-item__compare-price">
                          {item.priceComparison}
                        </span>
                      </Fragment>
                    )}
                    {item.maxPrice && (
                      <span className="product-list-item__compare-price">
                        {item.maxPrice}
                      </span>
                    )}
                  </p>
                  <div className="product-list-item__purchase-wrapper">
                    <QuantityInput 
                      quantityFieldId={item.id}
                      variantId={item.articleNumber}
                      placeholder={translate(
                        'code.product.quantity.placeholder'
                      )} 
                      className={`product-list-item__purchase-quantity ${
                        item.noQuantity ? 'no-quantity' : ''
                      }`}
                      includeInMultiPurchase={false}
                    />
                    <span className="product-list-item__purchase-button-wrapper">
                      <EnhancedBuyButton
                        stylePrefix={'buy-button'}
                        label={translate('code.product.buy')}
                        cssClass="button button--cta product-list-item__purchase-button product-list-item__purchase-button--quicksearch"
                        onClick={() => {
                          if(quantityFields[item.id].value){
                            return onClickHandler({ item });
                          } else {
                            dispatch(highlightQuantityInput(quantityFields[item.id].quantityFieldId));
                            return false;
                          }
                        }}
                      />
                    </span>
                  </div>
                </div>
              </article>
            )}
          </Fragment>
        ))}
    </div>
  );
};

export default QuickSearchResult;
